"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLogoutRequestEvent = exports.Name = void 0;
const Name = exports.Name = 'user-logout-request';
const UserLogoutRequestEvent = exports.UserLogoutRequestEvent = Name;
